import { Injectable, signal } from '@angular/core';
import { ConfirmationDialogData } from '@shared/models/confirmation.data.interface';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  private readonly dialogOpened = signal(false);
  private readonly dialogData = signal<ConfirmationDialogData | null>(null);

  openDialog(data: ConfirmationDialogData) {
    this.dialogData.set(data);
    this.dialogOpened.set(true);
  }

  closeDialog() {
    this.dialogOpened.set(false);
    this.dialogData.set(null);
  }

  isDialogOpened = this.dialogOpened;
  dialogContent = this.dialogData.asReadonly();
}
